module.exports = __webpack_public_path__ + "static/img/bonus_7.ad19530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/bonus_7.png
// module id = STjd
// module chunks = 0